import moment from 'moment';
import { I18N } from '../../constants';

export const handleMiscollectionValidations = ({
    trailerIdentifier,
    selectedDate,
    selectedStop,
    selectedReason,
    comment,
}) => {
    const tempValidations = {};

    if (trailerIdentifier && trailerIdentifier.length > 1000) {
        tempValidations.trailerIdentifier =
            'Trailer number cannot contain more than 1000 characters. ';
    }
    if (selectedDate && !moment(selectedDate).isValid()) {
        tempValidations.date = 'Please insert a valid date with format: DD-MM-YYYY HH:mm';
    } else if (selectedDate && selectedDate.isAfter(moment())) {
        tempValidations.date = 'A miscollection can not be registered in the future.';
    }
    if (selectedStop === I18N.FORMS.SELECT_STOP) {
        tempValidations.stop = 'You must select a location.';
    }
    if (selectedReason === I18N.FORMS.SELECT_REASON) {
        tempValidations.reason = 'You must select a reason.';
    }
    if (comment && comment.length > 1000) {
        tempValidations.comment = 'Comments cannot contain more than 1000 characters.';
    }

    return tempValidations;
};
